import { SALE_DETAILS } from "../../types/SaleType";
import axios from "axios";

const detailSaleAction = (data) => {
  return {
    type: SALE_DETAILS,
    payload: data,
  };
};

export const loadSingleSale = (id, type = 'sale') => {
  //dispatching with an call back function and returning that
  return async (dispatch) => {
    try {
      let endpoint;
      if (type === 'quotation') {
        endpoint = `quotation/${id}`;
      } else if (type === 'challan') {
        endpoint = `challan/${id}`;
      } else {
        endpoint = `sale-invoice/${id}`;
      }
      
      const response = await axios.get(endpoint);
      let data = response.data;
      
      // Normalize data structure to match sale invoice format
      // Sale invoice returns: {data: {singleSaleInvoice, ...}}
      // Quotation/Challan return: quotation/challan object directly
      
      let normalizedData;
      if (type === 'quotation') {
        // Quotation returns object directly, wrap it like sale invoice format
        const quotation = data.data || data;
        // Normalize product field name
        if (quotation.quotationInvoiceProduct) {
          quotation.saleInvoiceProduct = quotation.quotationInvoiceProduct;
          delete quotation.quotationInvoiceProduct;
        }
        // Quotations don't have paid_amount, due_amount, profit
        quotation.paid_amount = quotation.paid_amount || 0;
        quotation.due_amount = quotation.due_amount || 0;
        quotation.profit = quotation.profit || 0;
        quotation.document_type = 'quotation';
        
        normalizedData = {
          data: {
            singleSaleInvoice: quotation,
            status: "QUOTATION",
            // Other fields may not exist for quotations
            totalPaidAmount: 0,
            totalReturnAmount: 0,
            dueAmount: 0,
            returnSaleInvoice: [],
            transactions: [],
            totalUnitMeasurement: 0,
          }
        };
      } else if (type === 'challan') {
        // Challan returns object directly, wrap it like sale invoice format
        const challan = data.data || data;
        // Normalize product field name
        if (challan.challanInvoiceProduct) {
          challan.saleInvoiceProduct = challan.challanInvoiceProduct;
          delete challan.challanInvoiceProduct;
        }
        // Challans don't have paid_amount, due_amount, profit
        challan.paid_amount = challan.paid_amount || 0;
        challan.due_amount = challan.due_amount || 0;
        challan.profit = challan.profit || 0;
        challan.document_type = 'challan';
        
        normalizedData = {
          data: {
            singleSaleInvoice: challan,
            status: "CHALLAN",
            // Other fields may not exist for challans
            totalPaidAmount: 0,
            totalReturnAmount: 0,
            dueAmount: 0,
            returnSaleInvoice: [],
            transactions: [],
            totalUnitMeasurement: 0,
          }
        };
      } else {
        // Sale invoice response structure from backend:
        // {singleSaleInvoice, status, totalPaidAmount, totalReturnAmount, dueAmount, returnSaleInvoice, transactions, totalUnitMeasurement}
        // Reducer expects: action.payload.data with these fields
        if (data.singleSaleInvoice) {
          // Add document_type to singleSaleInvoice
          data.singleSaleInvoice.document_type = 'sale';
          
          // Wrap in data property for reducer
          normalizedData = {
            data: {
              singleSaleInvoice: data.singleSaleInvoice,
              status: data.status || 'UNPAID',
              totalPaidAmount: data.totalPaidAmount || 0,
              totalReturnAmount: data.totalReturnAmount || 0,
              dueAmount: data.dueAmount || 0,
              returnSaleInvoice: data.returnSaleInvoice || [],
              transactions: data.transactions || [],
              totalUnitMeasurement: data.totalUnitMeasurement || 0,
            }
          };
        } else if (data.data?.singleSaleInvoice) {
          // Already wrapped (shouldn't happen but handle it)
          data.data.singleSaleInvoice.document_type = 'sale';
          normalizedData = data;
        } else {
          // Fallback - wrap everything in data
          normalizedData = {
            data: {
              ...data,
              singleSaleInvoice: data,
              document_type: 'sale'
            }
          };
        }
      }
      
      //dispatching data
      dispatch(detailSaleAction(normalizedData));
    } catch (error) {
      console.log(error.message);
    }
  };
};
